<template>
  <vs-table
    :multiple="multiple"
    no-data-text="No tienes documentos relacionados"
    v-model="relatedDocumentsSelected"
    :data="relatedDocuments"
    class="table"
  >
    <template slot="thead">
      <vs-th>Relacionado con</vs-th>
      <vs-th>Nº Documento</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].type">
          {{ findLabelDocument(tr.type) }}
        </vs-td>
        <vs-td :data="data[indextr].number">
          {{ tr.number }}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
import FindLabelDocumentMixin from '@/febos/chile/dnt/mixins/FindLabelDocumentMixin';

export default {
  mixins: [FindLabelDocumentMixin],
  data() {
    return {
      relatedDocumentsSelected: this.value || []
    };
  },
  watch: {
    relatedDocumentsSelected() {
      this.$emit('input', this.relatedDocumentsSelected);
    },
    value(newValue) {
      this.relatedDocumentsSelected = newValue;
    }
  },
  props: {
    relatedDocuments: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
